import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import QrCodeValetService from "../../../../../services/QrCodeValetService";
import QrCodeGroupingService from "../../../../../services/QrCodeGroupingService";
import ParkingSlotsService from "../../../../../services/ParkingSlotsService";
import { floorsOptions } from "../../../../Enums/Fixed";

const AddQrCodeValetModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		qr_number: "",
		floor: "",
		login_number: "",
		zone: "",
		qr_group: "",
		parking_slot: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [parkingSlotOptions, setParkingSlotOptions] = useState([]);
	const [qrGroupOptions, setQrGroupOptions] = useState([]);
	// Per-field validation state for the react-select inputs.
	const [errors, setErrors] = useState({});
	const lang = useSelector((state) => state.auth.lang);
	const qrCodeValetService = new QrCodeValetService();
	const qrCodeGroupingService = new QrCodeGroupingService();
	const parkingSlotsService = new ParkingSlotsService();

	useEffect(() => {
		Promise.all([qrCodeGroupingService?.getList()]).then((res) => {
			let data = [];
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: info?.name,
						value: info?.id,
					};
				});
				setQrGroupOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					qr_number: item?.number,
					login_number: item?.login_number,
					qr_group: {
						label: item?.qr_group?.name,
						value: item?.qr_group?.id,
					},
					zone: {
						...data?.find((res) => res?.value === item?.zone_id),
						label: lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar,
						value: item?.zone_id,
					},
					parking_slot: {
						label:
							lang === "en"
								? item?.parking_slot?.name_en
								: item?.parking_slot?.name_ar,
						value: item?.slot_id,
					},
					floor: {
						label: item?.floor,
						value: item?.floor,
					},
				});
			}
		});
	}, []);

	useEffect(() => {
		if (!!formData?.zone?.value) {
			Promise.all([
				parkingSlotsService?.getList({
					zone_id: formData?.zone?.value,
					status: "empty",
				}),
			]).then((res) => {
				if (res[0]?.status === 200) {
					let data = res[0]?.data?.data?.data?.map((info) => {
						return {
							...info,
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					setParkingSlotOptions(data);
				}
			});
		}
	}, [formData?.qr_group]);

	const submit = (e) => {
		e.preventDefault();
		// react-select fields are invisible to AvForm's `required` rules, so
		// they have to be validated by hand.
		const nextErrors = {};
		if (!formData?.qr_group?.value) nextErrors.qr_group = true;
		if (!formData?.parking_slot?.value) nextErrors.parking_slot = true;
		if (!formData?.floor?.value) nextErrors.floor = true;

		setErrors(nextErrors);
		if (Object.keys(nextErrors).length) {
			toast.error(Translate[lang].field_required);
			return;
		}
		let data = {
			number: Number(formData?.qr_number),
			floor: Number(formData?.floor?.value),
			login_number: formData?.login_number,
			zone_id: formData?.zone?.value,
			qr_group_id: formData?.qr_group?.value,
			slot_id: formData?.parking_slot?.value,
		};

		setLoading(true);
		if (isAdd) {
			qrCodeValetService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			qrCodeValetService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.qr_code_valet}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* QR Code Group */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.qr_code_group}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.qr_group}
								name="qr_group"
								placeholder={Translate[lang]?.select}
								options={qrGroupOptions}
								onChange={(e) => {
									setFormData({
										...formData,
										qr_group: e,
										parking_slot: "",
										zone: {
											...e?.zone,
											label:
												lang === "en" ? e?.zone?.name_en : e?.zone?.name_ar,
											value: e?.zone_id,
										},
									});
									setErrors((prev) => ({ ...prev, qr_group: false }));
								}}
							/>
							{errors?.qr_group && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* Zone */}
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang]?.zone}</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								isDisabled
							/>
						</Col>
						{/* Parking Slot */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.parking_slot}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.parking_slot}
								name="parking_slot"
								placeholder={Translate[lang]?.select}
								options={parkingSlotOptions}
								onChange={(e) => {
									setFormData({ ...formData, parking_slot: e });
									setErrors((prev) => ({ ...prev, parking_slot: false }));
								}}
							/>
							{errors?.parking_slot && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* Floor */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.floor}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.floor}
								name="floor"
								placeholder={Translate[lang]?.select}
								options={floorsOptions}
								onChange={(e) => {
									setFormData({ ...formData, floor: e });
									setErrors((prev) => ({ ...prev, floor: false }));
								}}
							/>
							{errors?.floor && (
								<span className="star-require d-block mt-1">
									{Translate[lang].field_required}
								</span>
							)}
						</Col>
						{/* QR Code Number */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.qr_code_number}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.qr_code_number}
								bsSize="lg"
								name="qr_code_number"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.qr_number}
								onChange={(e) =>
									setFormData({
										...formData,
										qr_number: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={6} className="mb-3">
							<label>
								{Translate[lang]?.login_number}
								<span className="star-require">*</span>
							</label>
							{/* <PhoneInput
								country={"kw"}
								className="w-100"
								enableSearch={true}
								value={formData?.login_number}
								onChange={(e) => setFormData({ ...formData, login_number: e })}
							/> */}
							<AvField
								type="number"
								placeholder={Translate[lang]?.login_number}
								bsSize="lg"
								name="login_number"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.login_number}
								onChange={(e) =>
									setFormData({
										...formData,
										login_number: e.target.value,
									})
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.qr_code_valet}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddQrCodeValetModal;
